$(function () {
  const input = $('.c-select-search-input')
  const list = $('.c-select-search-options')

  if ($('.postcode-live-search').length > 0) {
    input.keyup(function() {
      if (input.val().length > 2) {
        $.ajax({
          url: '/locations/postcode_live_search',
          data: {
            request_term: $('.c-select-search-input').val()
          },
          dataType: 'json',
          success: function (response) {
            var results = $.map(response.data, function (location, _) {
              return {
                id: location.id,
                text: location.suburb + ', ' + location.state + ', ' + location.postcode,
                suburb: location.suburb,
                state: location.state,
                postcode: location.postcode,
              }
            })
            list.empty()

            $.each(results, function( index, value ) {
              list.append(
                $('<li>', {
                  'data-value': value.id,
                  'data-state': value.state,
                  tabindex: '-1',
                  text: value.text
                })
              )
            })
          },
          cache: true,
        });
      }
    });
  }
})
